module.exports = __webpack_public_path__ + "img/pin.3441fae0.svg";